import * as React from 'react';
import { Button, Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isRequired } from '../../../../../../util/validators';

interface IForgottenPasswordFormProps {
  actions: {
    push: (route: string) => void;
  };
  loading: boolean;
}

class ForgottenPasswordForm extends React.Component<IForgottenPasswordFormProps> {
  public render() {
    const { handleSubmit, loading } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="blue-section-group">
          <div className="blue-section">
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={3}>
                Email
              </Col>
              <Col sm={5}>
                <Field
                  name={'email'}
                  type="email"
                  placeholder="Email"
                  validate={[isRequired]}
                  autoComplete="new-password"
                  component={FieldFormControl}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        <div className="btn-bar">
          <div className="link-back">
            <Link to="/auth/login" className="pull-left">
              Back
            </Link>
          </div>
          <Button
            bsStyle="primary"
            type="submit"
            bsSize="lg"
            className="pull-right"
            disabled={loading}
          >
            RESET PASSWORD
          </Button>
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'forgotten_password',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('forgotten_password');
    return component;
  },
  connect(
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ForgottenPasswordForm);
